import React, { useState } from "react";
import { FaCamera } from "react-icons/fa";
import "../Styles/ProfileImageUploader.css";

const POProfileImageUploader = ({ 
  fullName, 
  profileImage, 
  location 
}) => {

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        overflow: "hidden",
        borderBottom: "4px solid rgb(34, 31, 31)",
        padding: "1rem"
      }}
    >
      {/* Profile Image */}
      <div
        className="po-profile-overlay"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "20%"
        }}
      >
        <img
          src={profileImage || "/default-avatar.png"}
          alt={fullName}
          className="po-profile-photo"
          style={{
            width: 150,
            height: 150,
            borderRadius: "50%",
            border: "4px solid white",
            objectFit: "cover"
          }}
        />
      </div>

      {/* Profile Info */}
      <div
        className="up-profile-header-format"
        style={{ marginLeft: "2rem", flexGrow: 1, marginTop: 100 }}
      >
        {fullName && (
          <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
            {fullName}
          </p>
        )}
        {location && (
          <p style={{ fontSize: "18px", color: "#777", margin: 0 }}>
            📍 {location}
          </p>
        )}
      </div>
    </div>
  );
};

export default POProfileImageUploader;